var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import DownOutlined from '@ant-design/icons/DownOutlined';
import omit from 'omit.js';
import DropDown from '../dropdown/dropdown';
import { ConfigConsumer } from '../config-provider';
let BreadcrumbItem = /** @class */ (() => {
    class BreadcrumbItem extends React.Component {
        constructor() {
            super(...arguments);
            this.renderBreadcrumbItem = ({ getPrefixCls }) => {
                const _a = this.props, { prefixCls: customizePrefixCls, separator, children } = _a, restProps = __rest(_a, ["prefixCls", "separator", "children"]);
                const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
                let link;
                if ('href' in this.props) {
                    link = (<a className={`${prefixCls}-link`} {...omit(restProps, ['overlay'])}>
          {children}
        </a>);
                }
                else {
                    link = (<span className={`${prefixCls}-link`} {...omit(restProps, ['overlay'])}>
          {children}
        </span>);
                }
                // wrap to dropDown
                link = this.renderBreadcrumbNode(link, prefixCls);
                if (children) {
                    return (<span>
          {link}
          {separator && separator !== '' && (<span className={`${prefixCls}-separator`}>{separator}</span>)}
        </span>);
                }
                return null;
            };
            /**
             * if overlay is have
             * Wrap a DropDown
             */
            this.renderBreadcrumbNode = (breadcrumbItem, prefixCls) => {
                const { overlay, dropdownProps } = this.props;
                if (overlay) {
                    return (<DropDown overlay={overlay} placement="bottomCenter" {...dropdownProps}>
          <span className={`${prefixCls}-overlay-link`}>
            {breadcrumbItem}
            <DownOutlined />
          </span>
        </DropDown>);
                }
                return breadcrumbItem;
            };
        }
        render() {
            return <ConfigConsumer>{this.renderBreadcrumbItem}</ConfigConsumer>;
        }
    }
    BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
    BreadcrumbItem.defaultProps = {
        separator: '/',
    };
    return BreadcrumbItem;
})();
export default BreadcrumbItem;
